<template lang="pug">
    .comment(v-if="content && !showPlaceholder")
        .comment__decore-wr.comment__decore-wr--1
            img.comment__decore.comment__decore--1(src="@/assets/img/decor/cube.svg" alt="decor")
        .comment__decore-wr.comment__decore-wr--2
            img.comment__decore.comment__decore--2(src="@/assets/img/decor/lightning.svg" alt="decor")
        .comment__decore-wr.comment__decore-wr--3
            img.tour__decore.comment__decore--3(src="@/assets/img/decor/straightedge.svg" alt="decor")
        .comment__decore-wr.comment__decore-wr--4
            img.tour__decore.tour__decore--4(src="@/assets/img/decor/glow-1.svg" alt="decor")
        h2.comment__headline {{ dataPage.headline }}
        .comment__list-wr
            .comment__list
                .comment__list-item(v-for="item in content" :key="item.id")
                    .comment__list-item-img-wr
                        img.comment__list-item-img(:src="item.img.path" :alt="item.img.title" :class="{'comment__list-item-img--height': imgHide}")
                    .comment__list-item-description
                        .comment__list-item-description-name {{ item.name }}
                        .comment__list-item-description-date {{ item.date }}
                        .comment__list-item-description-text {{ item.description }}
                        a.comment__list-item-description-link(v-if="item.link" :href="item.link" target="_blank") Ссылка на источник
                            .comment__list-item-description-link-title(v-if="item.title") {{ item.title }}
    .comment(v-else)
      .tour__decore-wr.tour__decore-wr--1
        img.tour__decore.tour__decore--1(src="@/assets/img/decor/cube.svg" alt="decor")
      .tour__decore-wr.tour__decore-wr--2
        img.tour__decore.tour__decore--2(src="@/assets/img/decor/lightning.svg" alt="decor")
      .tour__decore-wr.tour__decore-wr--3
        img.tour__decore.tour__decore--3(src="@/assets/img/decor/straightedge.svg" alt="decor")
      .tour__decore-wr.tour__decore-wr--4
        img.tour__decore.tour__decore--4(src="@/assets/img/decor/glow-1.svg" alt="decor")
      .tour__illustration
        img.tour__background(src="@/assets/img/development.svg" alt="illustration")
        img.tour__cogwheel-1(src="@/assets/img/cogwheel-1.svg" alt="cogwheel")
        img.tour__cogwheel-2(src="@/assets/img/cogwheel-2.svg" alt="cogwheel")
</template>

<script>
    // @ is an alias to /src
    import '@/components/comment/comment.styl';
    import EventBus from '@/eventBus';

    import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
    import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';

    export default {
        name: 'Comment',
        mixins: [AjaxHelpersVue],
        data() {
            return {
                content: null,
                objImages: [],
                imgHide: true,
                requestSend: false,
                commentsEnd: false,
                dataPage: null,
                showPlaceholder: false,
            }
        },
        components: {
            SvgIcon
        },
        created() {
            EventBus.$on('loadCommentPage', params => {
                this.request(params.url, params);
            });

            EventBus.$on('imgLoaded', (res) => {
                this.imgHide = res;
            });
        },
        methods: {
            request(url, params) {
                this.req('CommentPage:getCommentPage', {url}, res => {
                    this.dataPage = res.content;
                    EventBus.$emit('setMenuTopActiveClass', params.url, params.from);
                    EventBus.$emit('pagePreloaderHide');
                    this.innerRequest('CommentPage:getListOfComment', {url: url, count: 0}).then(response => {
                        if(this.checkProperty(response.comments)) {
                            this.content = response.comments;
                            this.showPlaceholder = response.showPlaceholder;
                            this.commentsEnd = response.end;
                            for(let i = 0; i < this.content.length; i++) {
                                this.objImages = this.objImages.concat({loaded: false, url: this.content[i].img.path});
                            }
                            this.$nextTick(() => {
                                $('.samedia').removeClass('samedia--hide');
                                $('.footer').removeClass('footer--hide');
                                $('.page__decore--12').removeClass('page__decore--hide-bottom');
                                $('.page__decore--11').removeClass('page__decore--hide-bottom');
                                $('.page__decore--10').removeClass('page__decore--hide-bottom');
                                this.checkImgLoading(this.objImages);
                                this.scrollInit();
                                this.parallax();
                            });
                        }
                    });
                }, 'comment');
            },
            scrollInit() {
                $('.comment__list-wr').mCustomScrollbar({
                    mouseWheel: {
                        enable: true
                    },
                    theme: "rounded-dark",
                    scrollEasing: "linear",
                    callbacks: {
                        onTotalScroll: () => {
                            if(this.requestSend === false) {
                                this.requestSend = true;
                                if (!this.commentsEnd) {
                                    $('.comment__list').css({'opacity': '0.5'});
                                    let countOfCommentsOnPage = $('.comment__list-item').length;
                                    let data = {
                                        url: this.$router.currentRoute.fullPath,
                                        count: countOfCommentsOnPage
                                    };
                                    this.innerRequest('CommentPage:getListOfComment', data).then((response) => {
                                        this.content = this.content.concat(response.comments);
                                        for(let i = 0; i < this.content.length; i++) {
                                            this.objImages = this.objImages.concat({loaded: false, url: this.content[i].img.path});
                                        }
                                        this.checkImgLoading(this.objImages);
                                        $('.comment__list').css({'opacity': '1'});
                                        if (response.end === true) {
                                            this.commentsEnd = true;
                                        }
                                        this.requestSend = false;
                                    });
                                }
                            }
                        },
                    },
                });
            },
            parallax() {
                $(document).on('mousemove', event => {
                    let offsetX = event.clientX;
                    let offsetY = event.clientY;
                    $('.comment__decore-wr--1').css('transform', `translate(${offsetX * 0.02}px, ${offsetY * -0.02}px)`).find('img').css('transform', `rotate(${offsetX * offsetY * 0.00001}deg)`);
                    $('.comment__decore-wr--2').css('transform', `translate(${offsetX * -0.01}px, ${offsetY * 0.01}px)`).find('img').css('transform', `rotate(${offsetX * offsetY * -0.00002}deg)`);
                    $('.comment__decore-wr--3').css('transform', `translate(${offsetX * -0.015}px, ${offsetY * 0.02}px)`).find('img').css('transform', `rotate(${offsetX * offsetY * 0.00005}deg)`);
                    $('.comment__decore-wr--4').css('transform', `translate(${offsetX * 0.01}px, ${offsetY * 0.015}px)`).find('img').css('transform', `rotate(${offsetX * offsetY *- 0.00002}deg)`);
                });
            }
        }
    }
</script>
